import Vue from 'vue'
import VueCookies from 'vue-cookies'
import loginHelpers from '../../helpers/loginHelpers'
import userEventLogHelpers from '../../helpers/userEventLogHelpers'

import axios from 'axios'
const vueObj = new Vue()

const state = {
  isLoggingIn: false,
  isLoggingOut: false,
  isRegistering: false,
  isValidEmail: false,
  isCheckingEmailAccount: false,
  user: null,
  professional: null,
  token: null,
  tokenProfessional: null,
  tokenTemp: null,
  fcmToken: null,
  registerSuccess: null,
  loginFormType: 'login',
  registeredPlatform: null,
  registerFrom: null,
  registerSuccessFromPage: false,
  referralCode: null,
  checkFavoriteTempData: null
}

const actions = {
  LOGIN: ({ commit }, submitData) => {
    return new Promise(async (resolve, reject) => {
      try {
        commit('REQUEST_LOGIN', true)
        const nonce = await loginHelpers.getNonce()
        if (nonce) {
          submitData.nonce = nonce
          const url = 'auth/login'
          const { data } = await axios.post(url, submitData)
          commit('REQUEST_LOGIN', false)
          if (!data.error) {
            // Set user data and jwt token
            loginHelpers.setLoginData(data)
            if (data.fcm_token) {
              commit('SET_FCM_TOKEN', data.fcm_token)
            }
            // Track Line Event
            let isFromLine = VueCookies.get('isFromLine')
            if (isFromLine && Number(data.new_user) === 1) {
              Vue.prototype.$lineTrack('Conversion')
            }
            userEventLogHelpers.logEvent('login', {
              method: submitData.social_name
            })
            resolve(data)
          } else {
            reject(new Error('Error: something went wrong'))
          }
        }
      } catch (error) {
        commit('REQUEST_LOGIN', false)
        let alertMessage = error.message
        if (error.response && error.response.data && error.response.data.message) {
          alertMessage = error.response.data.message
        }
        vueObj.$swal({ text: alertMessage, type: 'error' })
        reject(error)
      }
    })
  },
  LOGIN_PROFESSIONAL: ({ commit }, submitData) => {
    return new Promise(async (resolve, reject) => {
      const { data } = await axios.post('/professional/login-with-otp-password', {
        phone: submitData.phone, otp_password: submitData.otp_password
      })
      if (!data.error) {
        let params = {
          professional: {
            id: data.professional_id,
            picture: data.picture,
            name: data.name,
            province_id:
            data.province_id
          },
          token: data.token,
          token_temporary: data.token_temporary
        }
        loginHelpers.setLoginDataProfessional(params)

        resolve(data)
      } else {
        reject(data)
      }
    })
  },
  LOGIN_BYPASS_PROFESSIONAL: ({ commit }, payload) => {
    return new Promise(async (resolve, reject) => {
      try {
        let professional = payload.professional

        let params = {
          professional: {
            id: professional.id,
            picture: professional.picture,
            name: professional.name,
            province_id: professional.province_id
          },
          token: payload.access_token,
          token_temporary: payload.token_temporary
        }
        loginHelpers.setLoginDataProfessional(params)

        resolve(professional)
      } catch (err) {
        reject(err.message)
      }
    })
  },
  LOGOUT_PROFESSIONAL: ({ commit }) => {
    commit('SET_TOKEN_PROFESSIONAL', null)
    commit('SET_PROFESSIONAL', null)
    commit('SET_TOKEN_TEMP', null)
  },
  LOGOUT: ({ commit }, id) => {
    commit('REQUEST_LOGOUT')
    Vue.http.post('auth/logout', {
      user_id: id, platform: 'website'
    })
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_USER', null)
          commit('SET_TOKEN', null)
        }
      })
  },
  ADD_USER_TOKEN: ({ commit }, submitData) => {
    Vue.http.put('users/' + submitData.user_id + '/user-tokens', submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          console.log('updated token')
        }
      })
  },
  REGISTER: async ({ commit }, submitData) => {
    try {
      commit('SET_REGISTER_SUCCESS', false)
      // console.log(state)
      const url = 'register'
      const { data } = await axios.post(url, submitData)
      commit('SET_IS_REGISTERING', false)
      if (!data.error) {
        commit('SET_REGISTER_SUCCESS', true)
        userEventLogHelpers.logEvent('sign_up', {
          email: data.user.email,
          user_id: data.user.id,
          method: 'email_password'
        })
      } else {
        vueObj.$swal({ text: data.message, type: 'error' })
      }
    } catch (error) {
      let alertMessage = error.message
      if (error.response && error.response.data && error.response.data.message) {
        alertMessage = error.response.data.message
      }
      vueObj.$swal({ text: alertMessage, type: 'error' })
    }
  },
  VALIDATE_EMAIL: ({ commit }, submitData) => {
    Vue.http.post('validate-email', submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_VALID_EMAIL', false)
        if (!response.error) {
          commit('SET_IS_VALID_EMAIL', true)
        }
      })
  },
  LOAD_USER_PROFILE: async ({ commit }, userId) => {
    const url = `users/${userId}`
    const { data } = await axios.get(url)
    if (!data.error) {
      const userData = loginHelpers.getUserData(data)
      this.$store.commit('auth/SET_USER_DATA', userData)
    }
  },
  CHECK_EMAIL_ACCOUNT: async ({ commit }, submitData) => {
    try {
      const nonce = await loginHelpers.getNonce()
      if (nonce) {
        submitData.nonce = nonce
        commit('SET_REGISTERED_PLATFORM', null)
        commit('SET_IS_CHECKING_EMAIL_ACCOUNT', true)
        const url = 'check-email-account'
        const { data } = await axios.post(url, submitData)
        commit('SET_IS_CHECKING_EMAIL_ACCOUNT', false)
        let platform = null
        if (!data.error) {
          platform = data.platform
        }
        commit('SET_REGISTERED_PLATFORM', platform)
      }
    } catch (error) {
      let alertMessage = error.message
      if (error.response && error.response.data && error.response.data.message) {
        alertMessage = error.response.data.message
      }
      vueObj.$swal({ text: alertMessage, type: 'error' })
    }
  },
  async getToken ({ commit }, submitData) {
    const url = '/auth/get-token'
    const res = await axios.post(url, submitData)
    const response = res.data
    if (!response.error) {
      commit('SET_TOKEN', response.token)
    } else {
      console.log('invalid token')
    }
  }
}

const mutations = {
  REQUEST_LOGIN: (state, status) => {
    state.isLoggingIn = status
  },
  REQUEST_LOGOUT: (state) => {
    state.isLoggingOut = true
  },
  SET_IS_REGISTERING: (state, status) => {
    state.isRegistering = status
  },
  SET_PROFESSIONAL: (state, professional) => {
    state.professional = professional
  },
  SET_TOKEN_PROFESSIONAL: (state, token) => {
    state.tokenProfessional = token
  },
  SET_TOKEN_TEMP: (state, token) => {
    state.tokenTemp = token
  },
  SET_USER: (state, user) => {
    state.isLoggingIn = false
    state.isLoggingOut = false
    state.user = user
  },
  SET_USER_DATA: (state, user) => {
    state.user = user
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },

  SET_FCM_TOKEN: (state, fcmToken) => {
    state.fcmToken = fcmToken
  },
  SET_REGISTER_SUCCESS: (state, data) => {
    state.registerSuccess = data
  },
  SET_LOGIN_FORM_TYPE: (state, type) => {
    state.loginFormType = type
  },
  SET_IS_VALID_EMAIL: (state, status) => {
    state.isValidEmail = status
  },
  UPDATE_USER_DATA: (state, data) => {
    state.user[data.key] = data.value
  },
  SET_IS_CHECKING_EMAIL_ACCOUNT: (state, status) => {
    state.isCheckingEmailAccount = status
  },
  SET_REGISTERED_PLATFORM: (state, platform) => {
    state.registeredPlatform = platform
  },
  SET_REGISTER_FROM: (state, registerPage) => {
    state.registerFrom = registerPage
  },
  SET_REGISTER_SUCCESS_PAGE: (state, config) => {
    state.registerSuccessFromPage = config
  },
  SET_REFERRAL_CODE: (state, referralCode) => {
    state.referralCode = referralCode
  },
  SET_CHECK_FAVORITE_EXPERIENCE: (state, data) => {
    state.checkFavoriteTempData = data
  }
}

const getters = {
  getState: state => {
    return state
  },
  getUser: state => {
    return state.user
  },
  getToken: state => {
    return state.token
  },
  getRegisterSuccess: state => {
    return state.registerSuccess
  },
  getLoginFormType: state => {
    return state.loginFormType
  },
  getIsValidEmail: state => {
    return state.isValidEmail
  },
  getIsCheckingEmailAccount: state => {
    return state.isCheckingEmailAccount
  },
  isLoggingOut: state => {
    return state.isLoggingOut ? 'message.button.loading' : 'message.button.logout'
  },
  isRegistering: state => {
    return state.isRegistering ? 'message.button.signing_up' : 'message.button.sign_up'
  },
  getReferralCode: state => {
    return state.referralCode
  }
}

export default {
  namespaced: true, state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js